import { render, staticRenderFns } from "./ServiceList.vue?vue&type=template&id=5c539324&scoped=true&"
import script from "./ServiceList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ServiceList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ServiceList.vue?vue&type=style&index=0&id=5c539324&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c539324",
  null
  
)

export default component.exports